import { render, staticRenderFns } from "./measure.vue?vue&type=template&id=e968f866&scoped=true&"
import script from "./measure.vue?vue&type=script&lang=js&"
export * from "./measure.vue?vue&type=script&lang=js&"
import style0 from "./measure.vue?vue&type=style&index=0&id=e968f866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e968f866",
  null
  
)

export default component.exports